import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, FormArray, FormGroup, FormControl, ValidationErrors } from '@angular/forms';
import * as moment from 'moment';

@Injectable()
export class ValidatorsService {
	constructor() {}

	rango(menor: number, mayor: number): ValidatorFn {
		return (control: AbstractControl): { rango: number } | null => {
			const estaEnRango = control.value >= menor && control.value <= mayor ? true : false;
			return estaEnRango ? { rango: control.value } : null;
		};
	}

	noEspaciosVacios(): ValidatorFn {
		return (control: AbstractControl): { espaciosVacios: boolean } | null => {
			const tieneEspaciosVacios = control.value && control.value.trim().length === 0 ? true : false;
			return tieneEspaciosVacios ? { espaciosVacios: true } : null;
		};
	}

	fechaMenor(fecha: Date): ValidatorFn {
		return (control: AbstractControl): { fechaMenor: Date } | null => {
			const esFechaMenor = moment(control.value).isBefore(moment(fecha));
			return esFechaMenor ? { fechaMenor: control.value } : null;
		};
	}

	fechaMayor(fecha: Date): ValidatorFn {
		return (control: AbstractControl): { fechaMayor: Date } | null => {
			const esFechaMayor = moment(control.value).isAfter(moment(fecha));
			return esFechaMayor ? { fechaMayor: control.value } : null;
		};
	}

	fechaRango(fechaMenor: Date, fechaMayor: Date): ValidatorFn {
		return (control: AbstractControl): { fechaRango: Date } | null => {
			const esFechaRango = moment(control.value).isBetween(moment(fechaMenor), moment(fechaMayor));
			return esFechaRango ? { fechaRango: control.value } : null;
		};
	}

	/**
	 * Funcion que recorre cada control(Control, Group o Array) de un formulario reactivo de angular y los marca como Touched y dirty activando los validadores de cada control. * * Sirve para mostrar al usuario que campos estan invalidos de forma visual.
	 * @param formGroup forumlario a validar
	 */
	validateForm(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => {
			const control = formGroup.get(field);
			if (control instanceof FormControl) {
				control.markAsTouched({ onlySelf: true });
				control.markAsDirty({ onlySelf: true });
			} else if (control instanceof FormGroup) {
				this.validateForm(control);
			} else if (control instanceof FormArray) {
				const controlArray: FormArray = control;
				controlArray.controls.map(control => {
					if (control instanceof FormControl) {
						control.markAsDirty({ onlySelf: true });
						control.markAsTouched({ onlySelf: true });
					} else {
						const formGroup = control as FormGroup;
						this.validateForm(formGroup);
					}
				});
			}
		});
	}
}
